import { Sun } from "lucide-react";
import { useLang } from "./common";

const Row = ({ words, hidden }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden}>
    {words.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-display text-3xl sm:text-5xl lg:text-6xl px-6 sm:px-10 whitespace-nowrap ${i % 2 ? "text-stroke" : "text-white"}`}>{w}</span>
        <Sun className="w-7 h-7 sm:w-10 sm:h-10 text-[#F39C12] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t, lang } = useLang();
  return (
    <section data-testid="editorial-marquee" className="relative bg-[#0F295B] py-8 sm:py-10 overflow-hidden border-y-4 border-[#00A651]">
      <div className="marquee-track" key={lang}>
        <Row words={t.marquee} />
        <Row words={t.marquee} hidden />
      </div>
    </section>
  );
};
